import React from 'react';
import { DialogConsumer, DialogProvider } from 'providers';
import { DialogContextValue, DialogWrapperProps } from './types';

const DialogWrapper: React.FC<DialogWrapperProps> = ({ children }) => (
  <DialogProvider>
    <>
      <DialogConsumer>
        {({ dialog: Dialog, content: Content, wrapperProps, contentProps }: Partial<DialogContextValue>) => {
          if (Dialog) {
            return <Dialog {...wrapperProps}>{Content && <Content {...contentProps} />}</Dialog>;
          }
        }}
      </DialogConsumer>
      {children}
    </>
  </DialogProvider>
);

export default DialogWrapper;
